/**
 * Diary list distance helpers (Haversine from route-path-resolution).
 */

import { haversineDistanceMeters } from './route-path-resolution.util';

export type DiaryDistanceSortable = {
  entryDate?: string | null;
  constructionName?: string | null;
  centroidLat?: number | null;
  centroidLng?: number | null;
};

/**
 * Sort diaries: entryDate DESC, then by distance ASC when origin GPS known,
 * else constructionName ASC (cs).
 */
export function sortDiariesByDateThenDistance<T extends DiaryDistanceSortable>(
  rows: readonly T[],
  origin: { lat: number; lng: number } | null,
): T[] {
  const hasOrigin =
    origin != null && Number.isFinite(origin.lat) && Number.isFinite(origin.lng);
  return [...rows].sort((a, b) => {
    const byDate = String(b.entryDate ?? '').localeCompare(String(a.entryDate ?? ''));
    if (byDate !== 0) return byDate;
    if (hasOrigin && origin) {
      const da = haversineDistanceMeters(
        origin.lat,
        origin.lng,
        Number(a.centroidLat),
        Number(a.centroidLng),
      );
      const db = haversineDistanceMeters(
        origin.lat,
        origin.lng,
        Number(b.centroidLat),
        Number(b.centroidLng),
      );
      const daOk = Number.isFinite(da);
      const dbOk = Number.isFinite(db);
      if (daOk && dbOk && da !== db) return da - db;
      if (daOk && !dbOk) return -1;
      if (!daOk && dbOk) return 1;
    }
    return String(a.constructionName ?? '').localeCompare(String(b.constructionName ?? ''), 'cs');
  });
}
